import React, { useState } from "react";
import {
  Box,
  Button,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  MenuItem,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import { get, postJsonData } from "../network/ApiController";
import Loader from "../component/loading-screen/Loader";
import { whiteColor } from "../theme/setThemeColor";
import ModalHeader from "../modals/ModalHeader";
import ModalFooter from "../modals/ModalFooter";

const AddUserCharges = ({ refresh }) => {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState(false);
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState("");

  // 🔹 GET USERS
  const getUsers = () => {
    get(
      ApiEndpoints.GET_USERS,
      `page=1&paginate=10&role=Api&export=`,
      setRequest,
      (res) => {
        const usersArray = res?.data?.data || [];
        setUsers(
          usersArray.map((item) => ({
            id: item.id,
            name: item.name,
          })),
        );
      },
      (error) => apiErrorToast(error),
    );
  };

  const handleOpen = () => {
    setOpen(true);
    getUsers();
  };

  const handleClose = () => {
    setOpen(false);
    setUserId("");
  };

  // 🔹 SUBMIT ADD USER CHARGES
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    const data = {
      user_id: userId,
      min_amt: form.min_amt.value,
      max_amt: form.max_amt.value,

      payout1: form.payout1.value,
      payout2: form.payout2.value,
      payout3: form.payout3.value,
      payout4: form.payout4.value,
      payout5: form.payout5.value,
    };

    postJsonData(
      ApiEndpoints.CREATE_USER_CHARGES,
      data,
      setRequest,
      () => {
        okSuccessToast("User charges added successfully");
        if (refresh) refresh();
        handleClose();
      },
      (err) => apiErrorToast(err),
    );
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <Tooltip title="Add User Charges">
        <Button
          variant="outlined"
          className="refresh-icon-risk"
          onClick={handleOpen}
          startIcon={
            <IconButton sx={{ p: 0, color: whiteColor() }}>
              <AddCircleOutlineIcon />
            </IconButton>
          }
          sx={{ py: 0.3 }}
        >
          User Charges
        </Button>
      </Tooltip>

      <Drawer open={open} onClose={handleClose} anchor="right">
        <Box sx={{ width: 400 }} className="sm_modal">
          <Loader loading={request} />
          <ModalHeader title="Add User Charges" handleClose={handleClose} />

          <Box
            component="form"
            id="addUserChargesForm"
            onSubmit={handleSubmit}
            sx={{ "& .MuiTextField-root": { m: 2 } }}
          >
            <Grid container>
              {/* USER DROPDOWN */}
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="User"
                    select
                    size="small"
                    required
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                  >
                    {users.map((user) => (
                      <MenuItem key={user.id} value={user.id}>
                        {user.name} ({user.id})
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>

              {/* PAYOUT FIELDS */}
              {[1, 2, 3, 4, 5].map((num) => (
                <Grid item xs={12} key={num}>
                  <FormControl fullWidth>
                    <TextField
                      label={`Payout ${num}`}
                      name={`payout${num}`}
                      size="small"
                      required
                    />
                  </FormControl>
                </Grid>
              ))}
              {/* MIN AMOUNT */}
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="Min Amount"
                    name="min_amt"
                    type="number"
                    size="small"
                    required
                  />
                </FormControl>
              </Grid>

              {/* MAX AMOUNT */}
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="Max Amount"
                    name="max_amt"
                    type="number"
                    size="small"
                    required
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mr: 2 }}>
            <ModalFooter
              form="addUserChargesForm"
              type="submit"
              btn="Submit"
              disable={request}
            />
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default AddUserCharges;
